import saving from "../Assets/images/saving.svg";
import current from "../Assets/images/current.svg";
import fixed from "../Assets/images/fix-deposit.svg";
import recurring from "../Assets/images/recurring.svg";
import demat from "../Assets/images/demate.svg";
import nri from "../Assets/images/nri.svg";
import savingaccount from "../Assets/images/saving-account.svg";
import currentaccount from '../Assets/images/current-account.svg';
import fdccount from '../Assets/images/fixed-deposite.svg';
import rdaccount from '../Assets/images/recurring-deposite.svg';
import demateaccount from "../Assets/images/demate-account.svg";
import NRI from '../Assets/images/nri-account.svg'

export const options = [
  {
    value: "State bank of india(SBI)",
    label: "State bank of india(SBI)",
    balance: "09223766666",
    statement: "09223766666",
    customercare: "18004253800",
    netbanking: "https://corp.onlinesbi.sbi/corporate/sbi/",
  },
  {
    value: "Bank of Baroda(BOB)",
    label: "Bank of Baroda(BOB)",
    balance: "8468001111",
    statement: "8468001122",
    customercare: "18001024455",
    netbanking:
      "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking",
  },
  {
    value: "Axis Bank",
    label: "Axis Bank",
    balance: "18004195959",
    statement: "18004196969",
    customercare: "18605005555",
    netbanking: "https://www.axisbank.com/",
  },
  {
    value: "HDFC Bank",
    label: "HDFC Bank",
    balance: "18002703333",
    statement: "18002703355",
    customercare: "18002026161",
    netbanking: "https://netbanking.hdfcbank.com/netbanking/",
  },

  {
    value: "ICICI Bank",
    label: "ICICI Bank",
    balance: "9594612612",
    statement: "9594613613",
    customercare: "18002003344",
    netbanking: "https://www.icicibank.com/",
  },
  {
    value: "Kotak Mahindra Bank",
    label: "Kotak Mahindra Bank",
    balance: "1800270300",
    statement: "9971056767",
    customercare: " 18602662666",
    netbanking: "https://netbanking.kotak.com/knb2/#/login",
  },
  {
    value: "Bank of India(BOI)",
    label: "Bank of India(BOI)",
    balance: "9015135135",
    statement: "9810558585",
    customercare: "1800220229",
    netbanking: "https://bankofindia.co.in/",
  },
  {
    value: "Canara Bank",
    label: "Canara Bank",
    balance: "9015483483",
    statement: "9015734734",
    customercare: "18004250018",
    netbanking: "https://canarabank.com/net-banking",
  },
  {
    value: "Induslnd Bank",
    label: "Induslnd Bank",
    balance: "18002741000",
    statement: "9212299955",
    customercare: "18002677777",
    netbanking: "https://www.indusind.com/",
  },
  {
    value: "Punjab National Bank",
    label: "Punjab National Bank",
    balance: "18001802223",
    statement: "18001802223",
    customercare: "18001802222",
    netbanking: "https://netpnb.com/",
  },
  {
    value: "Allahabad Bank",
    label: "Allahabad Bank",
    balance: "9224150150",
    statement: "9224150150",
    customercare: "18005722000",
    netbanking: "https://www.netbanking.indianbank.in/jsp/startIBPreview.jsp",
  },
  {
    value: "Indian Bank",
    label: "Indian Bank",
    balance: "9677633000",
    statement: "8108781085",
    customercare: "18004250000",
    netbanking: "https://www.netbanking.indianbank.in/jsp/startIBPreview.jsp",
  },
  {
    value: "ABN Amro Bank",
    label: "ABN Amro Bank",
    balance: "1800112224",
    statement: "1800112224",
    customercare: "1800112224",
    netbanking:
      "https://www.abnamro.nl/en/personal/internet-and-mobile/internet-banking/index.html",
  },
  {
    value: "American Express",
    label: "American Express",
    balance: "1800446630",
    statement: "1800446630",
    customercare: "1800446630",
    netbanking: "https://www.americanexpress.com/en-in/account/login",
  },
  {
    value: "Andhra Bank",
    label: "Andhra Bank",
    balance: "9223011300",
    statement: "9223008586",
    customercare: "18004251515",
    netbanking:
      "https://www.unionbankofindia.co.in/en/Details/internet-banking",
  },
  {
    value: "AU Small Finance Bank",
    label: "AU Small Finance Bank",
    balance: "18001202586",
    statement: "18001212586",
    customercare: "180012001200",
    netbanking:
      "https://www.aubank.in/personal-banking/digital-banking/au-0101/au-0101-netbanking",
  },
  {
    value: "Bandhan Bank",
    label: "Bandhan Bank",
    balance: "9223008666",
    statement: "9223008777",
    customercare: "18002588181",
    netbanking: "https://retail.bandhanbank.com/",
  },
  //  { value: "Bank of Maharastra",
  //   label: "Bank of Maharastra",
  //   balance:"9222281818",
  //   statement:"9222281818",
  //   customercare:"18002334526",
  //   netbanking:"https://bankofmaharashtra.in/internet-banking",
  // },
  {
    value: "Barclays Bank",
    label: "Barclays Bank",
    balance: "03457345345",
    statement: "02260007888",
    customercare: "02260007888",
    netbanking: "https://www.netbanking.barclays.in/B002/login.jsp",
  },
  {
    value: "Bhartiya Mahila Bank",
    label: "Bhartiya Mahila Bank",
    balance: "9212438888",
    statement: "9212438888",
    customercare: "1147472100",
    netbanking:
      "https://www.thehindubusinessline.com/money-and-banking/bharatiya-mahila-bank-launches-net-banking/article62235875.ece",
  },
  {
    value: "Central Bank of India",
    label: "Central Bank of India",
    balance: "09555244442",
    statement: "9555144441",
    customercare: "1800221911",
    netbanking: "https://www.centralbank.net.in/#/",
  },
  {
    value: "Citi Bank",
    label: "Citi Bank",
    balance: "9880752484",
    statement: "9880752484",
    customercare: "1800210284",
    netbanking: "https://www.citi.com/login",
  },
  {
    value: "Corporation Bank",
    label: "Corporation Bank",
    balance: "9268892688",
    statement: "9268892688",
    customercare: "18004253555",
    netbanking: "https://corp.onlinesbi.sbi/corporate/sbi/sbi_home.html",
  },
  {
    value: "Cosmos Bank",
    label: "Cosmos Bank",
    balance: "9029013793",
    statement: "9029013793",
    customercare: "18002330234",
    netbanking:
      "https://online.cosmosbank.in/RetailCorporate/#/login/retailcorporate",
  },
  {
    value: "Union Bank of India",
    label: "Union Bank of India",
    balance: "09223008586",
    statement: "09223008486",
    customercare: "1800222244",
    netbanking:
      "https://www.unionbankofindia.co.in/en/Details/internet-banking",
  },
  {
    value: "DCB Bank",
    label: "DCB Bank",
    balance: "7506660011",
    statement: "7506660022",
    customercare: "02268997777",
    netbanking:
      "https://pib.dcbbank.com/corp/AuthenticationController?__START_TRAN_FLAG__=Y&FORMSGROUP_ID__=AuthenticationFG&__EVENT_ID__=LOAD&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=072&LANGUAGE_ID=001",
  },
  {
    value: "Dena Bank",
    label: "Dena Bank",
    balance: "9289356677",
    statement: "9278656677",
    customercare: "18002336427",
    netbanking:
      "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking",
  },
  {
    value: "Deutsche Bank",
    label: "Deutsche Bank",
    balance: "18001236601",
    statement: "18001236601",
    customercare: "18001236601",
    netbanking:
      "https://login.deutschebank.co.in/corp/AuthenticationController?__START_TRAN_FLAG__=Y&FORMSGROUP_ID__=AuthenticationFG&__EVENT_ID__=LOAD&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=200&LANGUAGE_ID=001",
  },
  {
    value: "Dhanlaxmi Bank",
    label: "Dhanlaxmi Bank",
    balance: "8067747700",
    statement: "8067747711",
    customercare: "04876613000",
    netbanking: "https://www.dhanbank.com/retail-netbanking/",
  },
  {
    value: "Federal Bank",
    label: "Federal Bank",
    balance: "8431900900",
    statement: "8431600600",
    customercare: "18004251199",
    netbanking: "https://www.fednetbank.com/",
  },
  {
    value: "HSBC Bank",
    label: "HSBC Bank",
    balance: "9611124722",
    statement: "9611124722",
    customercare: "18002663456",
    netbanking: "https://www.hsbc.co.in/ways-to-bank/online-banking/",
  },
  {
    value: "IDBI Bank",
    label: "IDBI Bank",
    balance: "18008431122",
    statement: "18008431133",
    customercare: "18002094324",
    netbanking: "https://www.idbibank.in/idbi-bank-internet-banking.aspx",
  },
  {
    value: "IDFC Bank",
    label: "IDFC Bank",
    balance: "18002700720",
    statement: "9289289960",
    customercare: "18004194332",
    netbanking:
      "https://www.idfcfirstbank.com/personal-banking/ways-to-bank/internet-banking-services",
  },
  {
    value: "Indian Overseas Bank(IOB)",
    label: "Indian Overseas Bank(IOB)",
    balance: "9210622122",
    statement: "8424022122",
    customercare: "18004254445",
    netbanking: "https://www.iobnet.co.in/ibanking/html/index.html",
  },
  {
    value: "India Post Payments",
    label: "India Post Payments",
    balance: "8424046556",
    statement: "8424026886",
    customercare: "18008899860",
    netbanking: "https://www.ippbonline.com/",
  },
  {
    value: "Karnataka Bank",
    label: "Karnataka Bank",
    balance: "18004251445",
    statement: "18004251446",
    customercare: "18004251444",
    netbanking: "https://karnatakabank.com/",
  },
  {
    value: "Karur Vysya Bank",
    label: "Karur Vysya Bank",
    balance: "9266292666",
    statement: "9266292665",
    customercare: "18602581916",
    netbanking: "https://www.kvb.co.in/ilogin/",
  },
  {
    value: "Kotak Mahindra Bank",
    label: "Kotak Mahindra Bank",
    balance: "18002740110",
    statement: "9971056767",
    customercare: "18602662666",
    netbanking: "https://netbanking.kotak.com/knb2/",
  },
  {
    value: "Lakshmi Vilas Bank",
    label: "Lakshmi Vilas Bank",
    balance: "888244115",
    statement: "9282441155",
    customercare: "18004252233",
    netbanking: "https://www.dbs.com/",
  },
  {
    value: "Oriental Bank of Commerce(OBC)",
    label: "Oriental Bank of Commerce(OBC)",
    balance: "8067205767",
    statement: "9915622622",
    customercare: "18001801235",
    netbanking: "https://orientalbank.com/",
  },
  {
    value: "Punjab & Sindh Bank",
    label: "Punjab & Sindh Bank",
    balance: "7039035156",
    statement: "9773056161",
    customercare: "18004198300",
    netbanking: "https://punjabandsindbank.co.in/",
  },
  {
    value: "RBL Bank",
    label: "RBL Bank",
    balance: "18004190610",
    statement: "922336633",
    customercare: "02261156300",
    netbanking: "https://www.rblbank.com/",
  },
  {
    value: "Royal Bank Of Scotland",
    label: "Royal Bank Of Scotland",
    balance: "9227148472",
    statement: "92227148472",
    customercare: "1800112224",
    netbanking: "https://orientalbank.com/",
  },
  {
    value: "South India Bank",
    label: "South India Bank",
    balance: "9223008488",
    statement: "9223866666",
    customercare: "18004251809",
    netbanking:
      "https://online.rblbank.com/corp/AuthenticationController?FORMSGROUP_ID__=AuthenticationFG&__START_TRAN_FLAG__=Y&__FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=176",
  },
  {
    value: "Sate Bank Of Bikaner & Jaipur",
    label: "Sate Bank Of Bikaner & Jaipur",
    balance: "9223766666",
    statement: "9223866666",
    customercare: "18001806005",
    netbanking: "https://retail.onlinesbi.sbi/",
  },
  {
    value: "Sate Bank Of Hyderabad",
    label: "Sate Bank Of Hyderabad",
    balance: "9223766666",
    statement: "9223866666",
    customercare: "18004251825",
    netbanking: "https://retail.onlinesbi.sbi/",
  },
  {
    value: "Sate Bank Of Mysore",
    label: "Sate Bank Of Mysore",
    balance: "9223766666",
    statement: "9223866666",
    customercare: "18004252244",
    netbanking: "https://retail.onlinesbi.sbi/",
  },
  {
    value: "Sate Bank Of Patiyala",
    label: "Sate Bank Of Patiyala",
    balance: "9223766666",
    statement: "9223866666",
    customercare: "18001802010",
    netbanking: "https://retail.onlinesbi.sbi/",
  },
  {
    value: "Sate Bank Of Travancore",
    label: "Sate Bank Of Travancore",
    balance: "9223766666",
    statement: "9223866666",
    customercare: "18004255566",
    netbanking: "https://retail.onlinesbi.sbi/",
  },
  {
    value: "Syndicate Bank",
    label: "Syndicate Bank",
    balance: "9015483483",
    statement: "9210332255",
    customercare: "180030113333",
    netbanking: "https://online.canarabank.in/",
  },
  {
    value: "Tamilnad Mercantile Bank(TMB)",
    label: "Tamilnad Mercantile Bank(TMB)",
    balance: "9211937373",
    statement: "9211947474",
    customercare: "18004250426",
    netbanking: "https://www.tmbnet.in/",
  },
  {
    value: "UCO Bank",
    label: "UCO Bank",
    balance: "18002740123",
    statement: "18002740123",
    customercare: "18002730123",
    netbanking: "https://www.ucobank.com/internet-banking",
  },
  {
    value: "Ujjivan Small Finance",
    label: "Ujjivan Small Finance",
    balance: "9243012121",
    statement: "9243032121",
    customercare: "18002082121",
    netbanking: "https://netbanking.ujjivansfb.in/Ujjivan/",
  },
  {
    value: "Unio Bank Of India",
    label: "Unio Bank Of India",
    balance: "09223008586",
    statement: "09223008486",
    customercare: "1800222244",
    netbanking: "https://www.unionbankofindia.co.in/en/home",
  },
  {
    value: "United Bank Of India",
    label: "United Bank Of India",
    balance: "9015431345",
    statement: "9223173933",
    customercare: "18003450345",
    netbanking: "https://www.unionbankofindia.co.in/en/home",
  },
  {
    value: "varachha Cooprative Bank Limited",
    label: "varachha Cooprative Bank Limited",
    balance: "02614008080",
    statement: "02614008080",
    customercare: "18002587750",
    netbanking: "https://www.varachhabank.com/",
  },
  {
    value: "Vijaya Bank",
    label: "Vijaya Bank",
    balance: "18004255885",
    statement: "18001035535",
    customercare: "18004259992",
    netbanking:
      "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking",
  },
  {
    value: "Yes Bank",
    label: "Yes Bank",
    balance: "9223920000",
    statement: "9223921111",
    customercare: "18001200",
    netbanking:
      "https://www.yesbank.in/digital-banking/online-banking/netbanking-services",
  },
  {
    value: "Andhara Pragathi Grameena Bank",
    label: "Andhara Pragathi Grameena Bank",
    balance: "9266921358",
    statement: "9266921358",
    customercare: "18004252045",
    netbanking: "https://apgbonline.in/APGB/",
  },
  {
    value: "Assam Gramin Vilash Bank",
    label: "Assam Gramin Vilash Bank",
    balance: "9555244442",
    statement: "3612464107",
    customercare: "3612464107",
    netbanking: "https://netbanking.agvbank.co.in/",
  },
  {
    value: "Bangiya gramin Vikash Bank",
    label: "Bangiya gramin Vikash Bank",
    balance: "03482224602",
    statement: "03482224602",
    customercare: "18001032222",
    netbanking: "https://wbgb.co.in/",
  },
  {
    value: "Baroda Gujarat Gramin",
    label: "Baroda Gujarat Gramin",
    balance: "7829977711",
    statement: "8468001122",
    customercare: "02766221883",
    netbanking:
      "https://bggbib.barodarrb.co.in/corpgj/AuthenticationController?FORMSGROUP_ID__=AuthenticationFG&__START_TRAN_FLAG__=Y&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=459",
  },
  {
    value: "Baroda Rajasthan Kshetriya Gramin Bank",
    label: "Baroda Rajasthan Kshetriya Gramin Bank",
    balance: "8880094411",
    statement: "8880094411",
    customercare: "1800229779",
    netbanking:
      "https://brkgbib.barodarrb.co.in/corprj/AuthenticationController?FORMSGROUP_ID__=AuthenticationFG&__START_TRAN_FLAG__=Y&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=647",
  },
  {
    value: "Baroda U.P.Gramin Bank",
    label: "Baroda U.P.Gramin Bank",
    balance: "180030101886",
    statement: "9986454440",
    customercare: "18001800225",
    netbanking: "https://upgbank.com/",
  },
  {
    value: "Bombay Mercantile Co Op Bank Limited",
    label: "Bombay Mercantile Co Op Bank Limited",
    balance: "9512004406",
    statement: "9512004407",
    customercare: "1800220854",
    netbanking: "https://www.bmcbankltd.com/",
  },
  {
    value: "Chaitanya Godavari Grammeena Bank",
    label: "Chaitanya Godavari Grammeena Bank",
    balance: "9090290912",
    statement: "9902988992",
    customercare: "18004256708",
    netbanking: "https://apgb.bank/",
  },
  {
    value: "Chhattisgarh Rajya Gramin Bank",
    label: "Chhattisgarh Rajya Gramin Bank",
    balance: "9289221579",
    statement: "9289221579",
    customercare: "18002332300",
    netbanking: "https://www.cedgerrbmb.in/CRGB/",
  },
  {
    value: "Dakshin Bihar Gramin Bank",
    label: "Dakshin Bihar Gramin Bank",
    balance: "18001807777",
    statement: "18001807777",
    customercare: "18001807777",
    netbanking: "https://bgb.net.in/",
  },
  {
    value: "Fino Payments Bank",
    label: "Fino Payments Bank",
    balance: "7022075566",
    statement: "7877788977",
    customercare: "02268681414",
    netbanking: "https://netbanking.finobank.com/*",
  },
  {
    value: "Gramin Bank Of Aryavart",
    label: "Gramin Bank Of Aryavart",
    balance: "8010924194",
    statement: "8010924194",
    customercare: "18001020304",
    netbanking: "https://prathamaupbank.com/InternetBanking.aspx",
  },
  {
    value: "Himachal Pradesh Gramin Bank",
    label: "Himachal Pradesh Gramin Bank",
    balance: "8001807777",
    statement: "8001807777",
    customercare: "18001807777",
    netbanking: "https://netbanking.hpgbank.in/",
  },
  {
    value: "Janaseva Sahakari Bank",
    label: "Janaseva Sahakari Bank",
    balance: "7208053730",
    statement: "7208053730",
    customercare: "18001200304",
    netbanking: "https://www.janasevabankpune.net/",
  },
  {
    value: "Karnataka Gramin Bank",
    label: "Karnataka Gramin Bank",
    balance: "9015800700",
    statement: "9015800700",
    customercare: "18001025250",
    netbanking:
      "https://netbanking.karnatakagrameenabank.com/PKGB/AuthenticationController?__START_TRAN_FLAG__=Y&FORMSGROUP_ID__=AuthenticationFG&__EVENT_ID__=LOAD&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=49&LANGUAGE",
  },
  {
    value: "Karnataka Vikas Grameen Bank",
    label: "Karnataka Vikas Grameen Bank",
    balance: "09278700859",
    statement: "09278700859",
    customercare: "180042597777",
    netbanking: "https://netbanking.kvgbank.com/KVGB/",
  },
  {
    value: "Kashi Gomti Samyut Gramin Bank",
    label: "Kashi Gomti Samyut Gramin Bank",
    balance: "5422220752",
    statement: "5422220298",
    customercare: "5422220298",
    netbanking: "https://kashigomtigramin.in/",
  },
  {
    value: "Kaveri Gramin Bank",
    label: "Kaveri Gramin Bank",
    balance: "9015800700",
    statement: "9015800700",
    customercare: "180042503232",
    netbanking:
      "https://netbanking.karnatakagrameenabank.com/PKGB/AuthenticationController?__START_TRAN_FLAG__=Y&FORMSGROUP_ID__=AuthenticationFG&__EVENT_ID__=LOAD&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=49&LANGUAGE",
  },
  {
    value: "Kerala gramin Bank",
    label: "Kerala gramin Bank",
    balance: "9015800400",
    statement: "9015800400",
    customercare: "4832733509",
    netbanking: "https://keralagbank.com/",
  },
  {
    value: "Madhya Bihar Gramin Bank",
    label: "Madhya Bihar Gramin Bank",
    balance: "18001807777",
    statement: "18001807777",
    customercare: "18001807777",
    netbanking: "https://bgb.net.in/",
  },
  {
    value: "Maharashtra Gramin Bank",
    label: "Maharashtra Gramin Bank",
    balance: "7834888867",
    statement: "7834888867",
    customercare: "18002332133",
    netbanking: "https://www.mgbconnect.in/MGB/",
  },
  {
    value: "Manipur Rural Bank",
    label: "Manipur Rural Bank",
    balance: "3852451590",
    statement: "3852451590",
    customercare: "3852451590",
    netbanking: "https://manipurruralbank.com/",
  },
  {
    value: "Narmada Jhabua Gramin",
    label: "Narmada Jhabua Gramin",
    balance: "18002336295",
    statement: "18002336295",
    customercare: "18002336295",
    netbanking: "https://mpgb.co.in/index.html",
  },
  {
    value: "Odisha Gramya Bank",
    label: "Odisha Gramya Bank",
    balance: "8010106686",
    statement: "8010106686",
    customercare: "6742353031",
    netbanking: "https://odishabank.in/",
  },
  {
    value: "Pallavan Grama Bank",
    label: "Pallavan Grama Bank",
    balance: "9289202222",
    statement: "9289202222",
    customercare: "04272402904",
    netbanking:
      "https://tamilnadugramabank.in/services/payments/internet-banking",
  },
  {
    value: "pragathi Krishna Gramin Bank",
    label: "pragathi Krishna Gramin Bank",
    balance: "9015800700",
    statement: "9015800700",
    customercare: "18001025250",
    netbanking: "https://karnatakagrameenabank.com/",
  },
  {
    value: "Prathama U.P.gramin Bank",
    label: "Prathama U.P.gramin Bank",
    balance: "9058215904",
    statement: "9058215904",
    customercare: "18001807777",
    netbanking: "https://upgbank.com/",
  },
  {
    value: "Punjab Gramin Bank",
    label: "Punjab Gramin Bank",
    balance: "18001807777",
    statement: "18001807777",
    customercare: "18001807777",
    netbanking: "https://pgb.org.in/",
  },
  {
    value: "Purvanchal Bank",
    label: "Purvanchal Bank",
    balance: "9266592669",
    statement: "9266592669",
    customercare: "5512230210",
    netbanking: "https://upgbank.com/",
  },
  {
    value: "Rajasthan Marudhara Gramin Bank",
    label: "Rajasthan Marudhara Gramin Bank",
    balance: "2912593100",
    statement: "2912593100",
    customercare: "2912593100",
    netbanking: "https://netbanking.rmgb.in/OnlineRMGB/",
  },
  {
    value: "Saptagiri Grameena Bank",
    label: "Saptagiri Grameena Bank",
    balance: "9540011233",
    statement: "9540011233",
    customercare: "8572233598",
    netbanking: "https://www.saptagirigrameenabank.in/index.php",
  },
  {
    value: "Sarva Haryana Gramin Bank",
    label: "Sarva Haryana Gramin Bank",
    balance: "18001807777",
    statement: "18001807777",
    customercare: "18001807777",
    netbanking: "https://shgb.co.in/",
  },
  {
    value: "Sarva UP Gramin Bank",
    label: "Sarva UP Gramin Bank",
    balance: "18008331555",
    statement: "18008331555",
    customercare: "18008331555",
    netbanking: "https://upgbank.com/",
  },
  {
    value: "Saurashtra Gramin Bank",
    label: "Saurashtra Gramin Bank",
    balance: "9289200123",
    statement: "9289200123",
    customercare: "02812482421",
    netbanking: "https://gujaratgb.in/",
  },
  {
    value: "Tamil Nadu Grama Bank",
    label: "Tamil Nadu Grama Bank",
    balance: "9289202222",
    statement: "9289202222",
    customercare: "04272522900",
    netbanking: "https://tamilnadugramabank.in/",
  },
  {
    value: "Tripura Gramin Bank",
    label: "Tripura Gramin Bank",
    balance: "03812300325",
    statement: "03812300325",
    customercare: "18001033470",
    netbanking: "https://www.tripuragraminbank.org/",
  },
  {
    value: "Utkal Grameen Bank",
    label: "Utkal Grameen Bank",
    balance: "8744820666",
    statement: "8744820666",
    customercare: "6652232285",
    netbanking: "https://utkalgrameenbank.co.in/lander",
  },
  {
    value: "Uttar Bihar Gramin Bank",
    label: "Uttar Bihar Gramin Bank",
    balance: "9223008811",
    statement: "9223025111",
    customercare: "7061082356",
    netbanking: "https://bgb.net.in/",
  },
  {
    value: "Vidharbha Konkan Gramin Bank",
    label: "Vidharbha Konkan Gramin Bank",
    balance: "7122224319",
    statement: "7122224319",
    customercare: "7122224319",
    netbanking: "https://www.vkgb.co.in/",
  },
  {
    value: "Andhra Pradesh Grameena Vikas",
    label: "Andhra Pradesh Grameena Vikas",
    balance: "9289222024",
    statement: "9289222021",
    customercare: "18001210354",
    netbanking: "https://apgvb.in/digital-banking/Internet-Banking",
  },
  {
    value: "Jammu & Kashmir Bank",
    label: "Jammu & Kashmir Bank",
    balance: "18001800234",
    statement: "18001800234",
    customercare: "01942481999",
    netbanking: "https://www.jkbankonline.com/",
  },
  {
    value: "Aryavrat Gramin Bank",
    label: "Aryavrat Gramin Bank",
    balance: "8010924194",
    statement: "8010924194",
    customercare: "18001020304",
    netbanking: "https://www.aryavart-rrb.com/",
  },
  {
    value: "Airtel Money",
    label: "Airtel Money",
    balance: "*121#",
    statement: "8800688006",
    customercare: "8800688006",
    netbanking: "https://www.airtel.in/bank/",
  },
  {
    value: "Equitas Small Finance Bank",
    label: "Equitas Small Finance Bank",
    balance: "18001031222",
    statement: "8086077575",
    customercare: "18001031222",
    netbanking: "https://www.equitasbank.com/",
  },
  {
    value: "Saraswat Bank",
    label: "Saraswat Bank",
    balance: "09223040000",
    statement: "09223040000",
    customercare: "1800229999",
    netbanking: "https://www.saraswatbank.com/",
  },
  {
    value: "City Union Bank",
    label: "City Union Bank",
    balance: "9278177444",
    statement: "04471225000",
    customercare: "04471225000",
    netbanking:
      "https://www.cityunionbank.com/cub-net-banking-cub-online-banking",
  },
  {
    value: "TJSB Bank",
    label: "TJSB Bank",
    balance: "9212005550",
    statement: "9212005550",
    customercare: "1800223466",
    netbanking: "https://www.tjsb.bank.in/",
  },
  {
    value: "DBS Bank",
    label: "DBS Bank",
    balance: "18002094555",
    statement: "18002094555",
    customercare: "18602103456",
    netbanking:
      "https://www.dbs.com/digibank/in/banking/ibanking/internet-banking",
  },
  {
    value: "Abhyudaya Bank",
    label: "Abhyudaya Bank",
    balance: "18003135235",
    statement: "18003135235",
    customercare: "1800223131",
    netbanking: "https://www.abhyudayabank.in/internetbanking/lhome.do",
  },
  {
    value: "Bharat Bank",
    label: "Bharat Bank",
    balance: "9223009999",
    statement: "9223009999",
    customercare: "9223009999",
    netbanking: "https://www.bharatbank.com/netbanking.html",
  },
  {
    value: "Standard Chartered",
    label: "Standard Chartered",
    balance: "18003451000",
    statement: "18003451000",
    customercare: "18003451000",
    netbanking: "https://www.sc.com/in/help/online-banking/",
  },
  {
    value: "SVC Bank",
    label: "SVC Bank",
    balance: "9029011133",
    statement: "9029011133",
    customercare: "18003132120",
    netbanking: "https://www.svcbank.com/personal-netbanking",
  },
  {
    value: "NKGSB Cooperative Bank Ltd",
    label: "NKGSB Cooperative Bank Ltd",
    balance: "9870977191",
    statement: "9870977191",
    customercare: "02228602000",
    netbanking: "https://nkgsb-bank.com/",
  },
  {
    value: "AP Mahesh Bank",
    label: "AP Mahesh Bank",
    balance: "9767664466",
    statement: "9767664466",
    customercare: "24615299",
    netbanking: "https://www.apmaheshbank.com/internet-banking.aspx",
  },
  {
    value: "Punjab & Maharashtra Co-op Bank",
    label: "Punjab & Maharashtra Co-op Bank",
    balance: "9289220675",
    statement: "9289220675",
    customercare: "1800223993",
    netbanking:
      "https://www.bankingsupport.org/pmc-net-banking-pmc-bank-online-banking/",
  },
  {
    value: "Nainital Bank Limited",
    label: "Nainital Bank Limited",
    balance: "18001804031",
    statement: "18001804031",
    customercare: "08069840140",
    netbanking: "https://www.nainitalbank.co.in/english/internet_banking.aspx",
  },
  {
    value: "Airtel Payments Bank",
    label: "Airtel Payments Bank",
    balance: "8800688006",
    statement: "8800688006",
    customercare: "8800688006",
    netbanking: "https://www.airtel.in/bank/login",
  },
  {
    value: "ING Vysya Bank",
    label: "ING Vysya Bank",
    balance: "09266292666",
    statement: "09266292666",
    customercare: "18602662666",
    netbanking: "https://www.ing.com.au/online-banking.html",
  },
  {
    value: "Finace Small Finance Bank Limited",
    label: "Finace Small Finance Bank Limited",
    balance: "180030100111",
    statement: "180030100111",
    customercare: "1800313313",
    netbanking: "https://www.aubank.in/",
  },
  {
    value: "PayNearby",
    label: "PayNearby",
    balance: "999490909",
    statement: "999490909",
    customercare: "999490909",
    netbanking: "https://paynearby.in/",
  },
  {
    value: "Jharkhand Rajya Gramin Bank",
    label: "Jharkhand Rajya Gramin Bank",
    balance: "6512202120",
    statement: "6512202120",
    customercare: "06512210095",
    netbanking: "https://inb.jrgb.in/JRGBOnline/",
  },
  {
    value: "NSDL Payments Bank",
    label: "NSDL Payments Bank",
    balance: "2269787301",
    statement: "2242022100",
    customercare: "2242022100",
    netbanking: "https://www.fpi.nsdl.co.in/web/Login.aspx",
  },
  {
    value: "Mehsana Urban Co-operative Bank",
    label: "Mehsana Urban Co-operative Bank",
    balance: "09266692668",
    statement: "09266692668",
    customercare: "02762246822",
    netbanking: "https://www.mucb.in/mucb/welcome",
  },
  {
    value: "Aurangabad District Central Co-operative Bank Limited",
    label: "Aurangabad District Central Co-operative Bank Limited",
    balance: "02402334492",
    statement: "02402334492",
    customercare: "02402334492",
    netbanking: "http://www.biharbank.bih.nic.in/",
  },
  {
    value: "Jana Small Finance Bank",
    label: "Jana Small Finance Bank",
    balance: "18002080",
    statement: "18002080",
    customercare: "18002080",
    netbanking: "https://ebanking.janabank.com/ib-retail-web/tenant/index",
  },
  {
    value: "Defence Pension Portal",
    label: "Defence Pension Portal",
    balance: "18001805325",
    statement: "18001805325",
    customercare: "18001805325",
    netbanking: "https://sparsh.defencepension.gov.in/",
  },
  {
    value: "National Pension System",
    label: "National Pension System",
    balance: "18002100080",
    statement: "18002100080",
    customercare: "18002100080",
    netbanking:
      "https://enps.nps-proteantech.in/eNPS/NationalPensionSystem.html",
  },
  {
    value: "MobikWik",
    label: "MobikWik",
    balance: "08069808320",
    statement: "08069808320",
    customercare: "08069808320",
    netbanking: "https://www.mobikwik.com/",
  },
  {
    value: "Bharat Petroleum Corporation Limited",
    label: "Bharat Petroleum Corporation Limited",
    balance: "1800224344",
    statement: "1800224344",
    customercare: "1800224344",
    netbanking: "https://www.bharatpetroleum.in/",
  },
  {
    value: "Controller General of Accounts",
    label: "Controller General of Accounts",
    balance: "01124665417",
    statement: "01124665417",
    customercare: "01124665417",
    netbanking: "https://cga.nic.in/",
  },
  {
    value: "West Bengal Integrated Financial Management System",
    label: "West Bengal Integrated Financial Management System",
    balance: "9038003413",
    statement: "9038003413",
    customercare: "9038003413",
    netbanking: "https://www.wbifms.gov.in/PORTAL/postlogin.html",
  },
  {
    value: "Direct Benefit Transfer of LPG",
    label: "Direct Benefit Transfer of LPG",
    balance: "01123740714",
    statement: "01123740714",
    customercare: "01123740714",
    netbanking: "https://mopng.gov.in/en",
  },
  {
    value: "Employee' Provident Fund Organisation",
    label: "Employee' Provident Fund Organisation",
    balance: "9966044425",
    statement: "9966044425",
    customercare: "14470",
    netbanking: "https://www.epfindia.gov.in/site_en/index.php",
  },
];

export const technology = [
  {
    id: 1,
    image: saving,
    title: "Savings Account",
    backContent:
      "Primarily for saving money and earning interest on the balance. ",
  },
  {
    id: 2,
    image: current,
    title: "Current Account",
    backContent:
      "Designed for businesses and individuals who need to make frequent transactions, like deposits and withdrawals. ",
  },
  {
    id: 3,
    image: fixed,
    title: "Fixed Deposit (FD) Account",
    backContent:
      "For depositing a fixed sum of money for a specific period, earning a higher interest rate than savings accounts. ",
  },
  {
    id: 4,
    image: recurring,
    title: "Recurring Deposit (RD) Account",
    backContent:
      "Allows for regular, fixed deposits over a period to accumulate savings. ",
  },
  {
    id: 5,
    image: demat,
    title: "Demat Account",
    backContent:
      "For holding and managing investments in shares and securities in electronic form. ",
  },
  {
    id: 6,
    image: nri,
    title: "NRI Accounts",
    backContent: "For Non Resident Indians to manage their finances in India. ",
  },
];

export const loan = [
  {
    id: 1,
    type: "Personal Loans",
    purpose: "Debt consolidation, major purchases",
    Term: "2-7 years",
    InterestRate: "Fixed",
    CollateralRequired: "No",
  },
  {
    id: 2,
    type: "Mortgages",
    purpose: "Home purchases, refinancing",
    Term: "15-30 years",
    InterestRate: "Fixed or Variable",
    CollateralRequired: "Yes (Property)",
  },
  {
    id: 3,
    type: "Auto Loans",
    purpose: "Vehicle purchases",
    Term: "3-7 years",
    InterestRate: "Fixed or Variable",
    CollateralRequired: "Yes (Vehicle)",
  },
  {
    id: 4,
    type: "Home Equity Loans",
    purpose: "Home improvements, major expenses",
    Term: "5-15 years",
    InterestRate: "Fixed",
    CollateralRequired: "Yes (Home Equity)",
  },
  {
    id: 5,
    type: "Student Loans",
    purpose: "Education financing",
    Term: "10-25 years",
    InterestRate: "Fixed or Variable",
    CollateralRequired: "No",
  },
];

export const investment = [
  {
    id: 1,
    title: "Brokerage Services",
    backContent:
      "Designed for businesses and individuals who need to make frequent transactions, like deposits and withdrawals. ",
  },
  {
    id: 2,
    title: "Wealth Management",
    backContent:
      "Comprehensive financial planning services for high net worth individuals, including investment management, tax planning, estate planning, and philanthropic strategies. ",
  },
  {
    id: 3,
    title: "Retirement Planning",
    backContent:
      "Specialized services for retirement preparation, including 401(k) management, IRA rollovers, and pension planning. Focus on long   term growth and income generation strategies.",
  },
  {
    id: 4,
    title: "Trust Services",
    backContent:
      "Fiduciary services for estate planning, asset protection, and wealth transfer. Professional management of trust assets and administration of beneficiary distributions.",
  },
  {
    id: 5,
    title: "Private Banking",
    backContent:
      "Exclusive services for ultra high net worth clients, including personalized investment strategies, family office services, and access to alternative investments.",
  },
  {
    id: 6,
    title: "Corporate Finance",
    backContent:
      "Investment banking services for corporations, including mergers and acquisitions, initial public offerings, debt and equity financing, and strategic advisory services.",
  },
];

export const blogData = [
  {
    id: "1",
    banner:require("../Assets/images/statement.jpg"),
    title: "What Is a Bank Statement and Why Is It Important?",
    shortdisc: "Learn what a bank statement is, what information it contains, and why it plays an important role in tracking finances, verifying transactions, and managing money effectively.",
    intro:
      "Navigating your financial landscape requires a clear understanding of what is bank statement  a document that charts the course of your transactions. As digital banking reshapes our financial interactions, understanding every detail of a bank account statement isessential. It's a crucial tool for tracking your account's activity and a guard against fraud, steering you securely through your financial voyage.",
     sections: [
      {
        heading: "What Is a Bank Statement?",
        content:[
          "A bank statement is a summary provided by a bank that shows account activity for a defined time frame. It includes information such as money deposited, money withdrawn, transfers, service charges, and the opening and closing balance.",
          "Bank statements can be received in physical form or accessed digitally through online or mobile banking platforms. Regardless of the format, the purpose remains the same  to give account holders a transparent view of their financial activity.",
        ]
      },
      {
        heading: "How does a bank statement work?",
        content:[
          "The bank account statement is a detailed ledger that records your banking transactions. The statement is presented in a sequential timeline and distinguishes between debits for funds deducted and credits for funds deposited.",
          "Each transaction showcases specific details, such as the date, amount, and counterparty's information. This ensures that you have a precise account of your financial movements at your fingertips, allowing personal financial oversight and planning."
          
        ]
      },
      {
        heading: "What are the features of a bank account statement?",
        content:[
          "Bank account statements are not just mere records; they are powerful tools designed to enhance your financial awareness and security. Notable features are as follows:"
        ],
        points: [
          "Monitor account balance: Stay informed about your financial standing, allowing you to make timely decisions about spending and saving.",
          "Fee and interest tracking: Keep tabs on bank charges and earnings, which ensures that you're always aware of how these affect your overall financial health.",
          "Identify fraud: Spot unauthorised transactions swiftly, providing a crucial layer of protection against potential financial theft or discrepancies.",
        ],
      },
      {
        heading: "How to get a bank statement?",
        points: [
          "Online: Quickly access your bank statement by logging into your Internet Banking or Mobile Banking account and downloading or viewing your statement directly. If you're wondering how to download bank statement, the process is simple and often involves just a few clicks after logging into your online banking account.",
          "Offline: Alternatively, visit a branch or ATM to obtain a physical copy of your bank account statement for a tangible record of your transactions.",
        ],
      },
       {
        heading: "Benefits of a bank statement",
        content:[
          "Regular scrutiny of your bank statement extends beyond mere record keeping; it's pivotal for maintaining robust financial health. Here are the enhanced benefits of this practice "
        ],
        points:[
          "Financial planning: It lays the groundwork for effective budgeting and financial forecasting by providing a clear picture of past transactions and current balances." ,
          "Creditworthiness: Regular monitoring aids in maintaining a healthy account, essential for loan approvals and credit assessments.",
          "Error rectification: Swift detection of discrepancies enables timely rectification, ensuring your finances are always accurate.",
          "Informed decision making: With comprehensive transaction insights, you can make well informed decisions about savings, investments, and expenditures."
        ],
       
      },
      {
        heading: "What Information Does a Bank Statement Contain?",
        content:[
          "A typical bank statement includes:"
        ],
        points: [
          "Account holder’s name and account number",
          "Statement period",
          "Opening balance",
          "Deposits and credits",
          "Withdrawals and debits",
          "Bank charges and fees",
          "Closing balance"
        ],
        h2: [
          "By regularly reviewing bank statements, individuals can make better financial decisions and avoid unnecessary charges."
        ],
      },
      {
        heading: "Common Uses of Bank Statements",
        content:[
          "Bank statements are commonly used for:"
        ],
        points: [
          "Personal budgeting and expense tracking",
          "Loan or credit assessments",
          "Income verification",
          "Tax related documentation",
          "Financial planning"
        ],
        h2: [
          "Many institutions rely on bank statements to understand a person’s financial behavior over time."
        ],
      },
      {
        heading: "Importance of Reviewing Bank Statements Regularly",
        content:[
          "Failing to review bank statements can lead to missed errors or unnoticed charges. Regular checking allows users to quickly identify issues and contact their bank if discrepancies appear." 
        ],
       
      },
      
      {
        heading: "Keeping Bank Statements Secure",
        content:[
          "Since bank statements contain sensitive financial data, they should be stored securely. Digital statements should be accessed only through trusted devices, and physical copies should be kept in a safe place.",

          "Understanding bank statements is a foundational step toward building strong financial awareness and maintaining control over personal finances.",

        ]
      }
    ]
  },
  {
    id: "2",
    banner:require("../Assets/images/type.png"),
    title: "Different Types of Bank Accounts Explained",
    shortdisc: "Understand the different types of bank accounts, their purposes, and how choosing the right account can help manage personal and business finances more efficiently.",
    intro:
      "Bank accounts are designed to serve different financial needs. Choosing the right type of bank account can help individuals manage their money more effectively and achieve their financial goals.",
     sections: [
      {
        heading: "Why Are There Different Types of Bank Accounts?",
        content:
          "People use banks for various purposes such as saving money, daily transactions, business operations, or long term investments. To meet these needs, banks offer different account types, each with its own features and benefits."
      },
      {
        heading: "1. Savings Account",
        content:[
          "A savings account is one of the most common types of bank accounts. It is primarily used to store money safely while earning interest. Savings accounts allow limited transactions and are suitable for personal use.",
          "Key features include:"
        ],
        points: [
          "Interest on deposited funds",
          "Easy access to money",
          "Low minimum balance requirements"
        ]
      },
      {
        heading: "2. Current Account",
        content:[
          "A current account is mainly used by businesses, traders, and professionals who require frequent transactions. These accounts are designed for high volume transactions and usually do not offer interest.",
          "Key features include:"
        ],
        points: [
          "Unlimited deposits and withdrawals",
          "Overdraft facilities in some cases",
          "Suitable for business operations"
        ]
      },
      {
        heading: "3. Fixed Deposit Account",
        content:[
          "A fixed deposit account allows users to deposit a lump sum for a fixed period at a predetermined interest rate. The money remains locked for the chosen duration, encouraging long term savings.",
         "Key features include:" 
        ],
        points: [
          "Fixed interest rate",
          "Predictable returns",
          "Suitable for long term financial planning"
        ]
      },
      {
        heading: "4. Recurring Deposit Account",
        content:[
          "A recurring deposit account helps individuals save money regularly by depositing a fixed amount every month. It is ideal for people who want to develop a consistent saving habit.",
          "Key features include:"
        ],
        points: [
          "Monthly deposits",
          "Fixed tenure",
          "Encourages disciplined savings"
        ]
      },
      {
        heading: "Choosing the Right Account",
        content:[
          "The right bank account depends on individual needs such as income, spending habits, and financial goals. Understanding the purpose of each account type helps users make informed choices.",

          "Selecting the appropriate bank account is an important step toward effective money management and financial stability.",

        ]
      }
    ]
  },
  {
    id: "3",
    banner:require("../Assets/images/digital banking.jpg"),
    title: "How Digital Banking Is Changing Financial Services",
    shortdisc: "Explore how digital banking has transformed financial services by making banking faster, more convenient, and accessible through online and mobile platforms.",
     intro:[
       "Digital banking has significantly transformed the way people interact with financial services. With the growth of technology, banking has become more accessible, faster, and convenient than ever before."
     ],
     sections: [
      {
        heading: "What Is Digital Banking?",
        content:[
          "Digital banking refers to the use of electronic platforms such as websites and mobile applications to access banking services. It allows users to perform various banking tasks without visiting a physical branch.",
          
        ]
      },
      {
        heading: "Common Digital Banking Services",
        content:[
          "Digital banking typically includes services such as:"
        ],
        points: [
          "Checking account balances",
          "Transferring funds",
          "Paying bills",
          "Managing account details",
          "Viewing transaction history"
        ],
         h2: [
          "These services are available around the clock, offering flexibility and ease of use."
        ],
      },
      {
        heading: "Benefits of Digital Banking",
        content:[
          "Digital banking offers several advantages:"
        ],
        points: [
          "Convenience of accessing services anytime",
          "Faster transaction processing",
          "Reduced dependency on physical branches",
          "Improved financial tracking",
          // "Financial planning"
        ],
        h2: [
          "These benefits have made digital banking increasingly popular among users."
        ],
      },
      {
        heading: "Impact on Customers",
        content:[
          "Digital banking has empowered customers by giving them greater control over their finances. Users can monitor spending, receive alerts, and manage accounts with minimal effort." 
        ],
       
      },
       {
        heading: "Security and Awareness",
        content:[
          "While digital banking offers convenience, users should remain cautious. Using strong passwords, avoiding public networks, and accessing services only through official platforms can help maintain account security." 
        ],
       
      },
      
      {
        heading: "The Future of Digital Banking",
        content:[
          "As technology continues to evolve, digital banking is expected to introduce more advanced features that improve user experience and financial accessibility.",

          "Digital banking plays an important role in modern financial systems by making financial services more efficient and user friendly.",

        ]
      }
    ]
  },
   {
    id: "4",
    banner:require("../Assets/images/netbanking.jpg"),
    title: "What Is Net Banking How Net Banking is Works?",
    shortdisc: "Discover how net banking has transformed traditional banking by offering fast, secure, and convenient financial services through online platforms.",
     intro:[
       "Net banking, also known as internet banking, is an electronic system managed by banks which enables customers to access financial as well as non financial banking products online. Earlier, customers had to visit the banks even for a small service. However, after the arrival of internet banking, almost all the services and products can be accessed online. From fund transfer to requesting demand draft, net banking facilities, and all banking essentials. It is not just convenient but also a secure method of banking."
     ],
     sections: [
      {
        heading: "How Net Banking Works",
        content:[
          "Net banking, also known as internet banking, is an electronic system managed by banks which enables customers to access financial as well as non financial banking products online. Earlier, customers had to visit the banks even for a small service. However, after the arrival of internet banking, almost all the services and products can be accessed online. From fund transfer to requesting demand draft, net banking facilities, and all banking essentials. It is not just convenient but also a secure method of banking.",
          
        ]
      },
      {
        heading: "Features of Net Banking",
        content:[
          "Net banking comes with a plethora of features designed to simplify your banking experience:"
        ],
        points: [
          "Account Management: Check your account balance. view transaction history. and download statements.",
          "Fund Transfers: Transfer money between your own accounts or to other accounts within the same bank or different banks through NEFT. RTGS, and IMPS.",
          "Bill Payments: Pay utility bills, credit card bills, and other recurring payments easily.",
          "Investment Services: Manage your investments, including Fixed Deposits, Recurring Deposits, Mutual Funds, NPS, PPF among others.",
          "Loan Services: Apply for loans and check loan statements."
        ],
      },
      {
        heading: "Advantages of Net Banking",
        content:[
          "The benefits of net banking are vast and cater to the modern lifestyle:"
        ],
        points: [
          "Convenience: You can perform banking transactions from the comfort of your home or office without the need to visit a physical branch.",
          "Speed: Complete transactions in seconds. whether it's transferring funds, paying bills, or checking account details",
          "Accessibility: Access your bank accounts anytime, anywhere using any device with an internet connection, including smartphones,tablets, and computers.",
          "24/7 availability: Unlike traditional banking hours, net banking is available round the clock, allowing you to manage your finances at your convenience.",
          "Environmental friendly: Opt for electronic statements and receipts, significantly reducing paper usage and contributing to environmental conservation."
        ],
      },
      {
        heading: "Limitations of Net Banking",
        content:[
          "Despite its numerous advantages, net banking also has some limitations:"
        ],
        points: [
          "Internet Requires a stable and secure internet connection to perform transactions, which might be a challenge in areas with poor connectivity.",
          "Security risks: Potential for cyber threats such as phishing attacks, malware, and hacking if proper security measures are not taken by the user.",
          "Technical issues: Occasional technical glitches or scheduled maintenance can disrupt access to net banking services, causing inconvenience.",
          "Transaction limits: There might be limitations on the amount that can be transferred online, requiring you to visit a branch for larger transactions.",
        ],
      },
      {
        heading: "Safety Tips for Net Banking",
        points:[
          "Never share login credentials" ,
          "Use strong passwords",
          "Avoid public Wi-Fi",
          "Always log out after use"
        ],
        h2: [
          "Net banking has made financial management easier and more accessible for users worldwide."
        ],
       
      },
      
    ]
  },
    {
    id: "5",
    banner:require("../Assets/images/bank-balance.jpg"),
    title: "How to check your bank balance?",
    shortdisc: "Explore simple and secure ways to check your bank balance and stay updated on your finances using online, mobile, and traditional banking methods.",
     intro:[
       "Checking your bank balance regularly helps you stay on top of your finances. It is no longer a time consuming task and you can do so with the tap of a few buttons on your phone now. It helps in spotting unauthorised transactions or avoiding penalties for not maintaining adequate account balance."
     ],
     sections: [
      {
        heading: "What is bank balance?",
        content:[
          "Your bank balance is the amount of money available in your bank account at a particular time. It includes the sum of all deposits (savings) and deductions (expenses) made. Whether you're using a Savings Account, Current Account or any other account, keeping an eye on your bank balance is crucial for your financial health.",
          
        ]
      },
      {
        heading: "How can I check my bank balance?",
        content:[
          "Via bank passbook :",
          "A bank passbook is the traditional method to check your bank balance. This physical book has records of all transactions made in your account. You need to visit your bank branch or ATM to get your passbook updated (many banks have passbook printing machines).However, it requires manual effort and can time consuming."
          
        ],
      },
      {
        content:[
          "Via ATM :",
          "Simply insert your Debit Card into the ATM kiosk, enter your PIN and select the option to view your balance. Most banks have a wide ATM network, making it an easily accessible option. You can also print a mini statement to get a quick overview of your recent transactions."
        ],
      },
      {
        content:[
          "Via Internet banking :",
          "Log into your bank's online portal to view your balance, download statements and manage your account. You can also transfer funds, pay bills and invest money easily."
        ],
      },
      {
        content:[
          "SMS banking :",
          "SMS banking is a simple way to check your balance, especially useful if you don't have internet access. This method is valid when you have registered a mobile number to your account and you send the SMS from that number only."
        ],
      },
      {
        content:[
          "Mobile banking apps :",
          "Mobile banking apps have a user friendly interface and convenient features. You can download your bank's app, log in with your credentials and get 24/7 access to your account. With the rise of UPI apps, you can also check your balance if you've registered your account."
          
        ]
      },
       {
        content:[
          "Missed call service :",
          "Many banks offer a service to check your bank balance by simply giving a missed call to the bank's specified number. The numbers are toll free. "
        ]
      },
       {
        content:[
          "Checking bank balance With account :",
          "Checking balance with just your account number is usually not recommended and needs additional verification steps due to security reasons. If you're doing it online, you will need to verify with your card details or login credentials. If you're contacting the customer care, you might have to verify with your name, Dog and address."
        ]
      },
    ]
  },
    {
    id: "6",
    banner:require("../Assets/images/digital-banking.jpg"),
    title: "Importance of digital banking",
    shortdisc: "Explore how digital banking has transformed financial services by making banking faster, more convenient, and accessible through online and mobile platforms.",
     intro:[
       "From the ease of accessing everyday banking functions on varied devices to cashless payments in various stores, digital banking appears to be the future. Most people have never visited their bank branch physically even once, because of this convenience. The benefit of going paperless is an added bonus."
     ],
     sections: [
      {
        heading: "What is Digital Banking?",
        content:[
          "When you use online platforms and technology to access traditional banking services, it is called digital banking. With a single click of a button on your smartphone or computer, you can manage accounts, check balances and statements, transfer money, shop, pay bills, and apply for loans from anywhere and anytime. This means you no longer need your withdrawal slips or keep waiting for a requested account statement.",
        ]
      },
      {
        heading: "Importance of digital banking",
        content:[
          "1. Convenient and accessible :",
          "You can access your accounts and perform transactions anytime and anywhere. With the widespread use of smartphones, mobile banking apps offer a convenient way to manage finances on the go."
          
        ],
      },
      {
        content:[
          "2. Better customer experience :",
          "Digital banking platforms use data analytics to offer personalised financial advice and tailored services. Also, the easy to navigate interfaces help in improving your overall experience."
        ],
      },
      {
        content:[
          "3. Cost efficiency :",
          "Digital banking reduces the need for physical branches and associated costs, allowing banks to operate more efficiently. You can benefit from lower fees compared to traditional banking services."
        ],
      },
      {
        content:[
          "4. Enhanced security :",
          "Digital banking uses robust security protocols, including encryption, two factor authentication, and biometric verification. Immediate notifications and real time monitoring help detect and prevent fraudulent activities."
        ],
      },
      {
        content:[
          "5. Efficiency and speed :",
          "Transactions, including payments and transfers, are processed quickly and efficiently. Features like automatic bill payments and digital wallets streamline financial management."
          
        ]
      },
       {
        content:[
          "6. Environmental impact :",
          "Digital banking reduces the need for paper statements and documentation, contributing to environmental sustainability. Fewer physical branches mean reduced energy consumption and a lower carbon footprint. "
        ]
      },
       {
        content:[
          "7. Global reach :",
          "Digital banking facilitates international transactions and services, making it easier for businesses and individuals to operate globally. Online platforms often offer competitive exchange rates and streamlined currency conversion services."
        ]
      },
    ]
  },
];

export const accounttypes=[
  {
    id:1,
    title:"Savings Account",
    image:savingaccount,
    sections:[
       {
        heading: "What Is a Savings Account?",
        content:[
          "A savings account is an account at a bank or credit union that is designed to hold your money. Savings accounts typically pay a modest interest rate, but they are considered safe for parking cash that you want available for short term needs.",
          "Some savings accounts pay a higher yield than other savings accounts. They may have some limitations on how often you can withdraw funds. Generally, savings accounts offer flexibility that can be ideal for building an emergency fund, saving for a short term goal like buying a car or going on vacation, or simply earning a little interest on your savings."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "Savings accounts are bank or credit union accounts designed to keep your money safe while paying interest.",
          "Your savings account funds will be easily accessible, which can be an ideal option for emergency funds.",
          "You’ll typically earn a lower rate in savings accounts versus other options like CDs or bonds.",
          "The interest you earn on a savings account is considered taxable income.",
        ],
      },
      {
        heading: "How Savings Accounts Work",
        content:[
          "Savings and other deposit accounts are secure bank accounts used to store your funds while potentially earning interest.",
          "For banks, they are important sources of funds for lending. For that reason, you can find savings accounts at virtually every bank or credit union, whether they are traditional brick and mortar institutions or operate online. In addition, some investment and brokerage firms offer savings accounts.",
          "Savings account interest rates vary. With the exception of promotions promising a fixed rate until a certain date, banks and credit unions might change their rates at any time. Typically, the more competitive the rate, the more likely it is to fluctuate.",
          "Changes in the federal funds rate can trigger institutions to adjust their deposit rates. U.S. Consumer Financial Protection Bureau. The Fed is raising interest rates. What does that mean for borrowers and savers? Some institutions offer high yield savings accounts with significantly higher interest rates for larger minimum deposits, which may be worth investigating."
        ],
      },
      {
        heading: "Savings Account Rules",
        content:[
          "Some conventional savings accounts require a minimum balance to avoid monthly fees or earn the highest published rate, while others have no balance requirement. Know the rules of your particular account to ensure you avoid diluting your earnings with fees.",
          "Money can be transferred in or out of your savings account online, at a branch or ATM, by electronic transfer, or by direct deposit. Transfers can usually be arranged by phone, as well.",
          "Some banks limit withdrawals to six per month. If you exceed that, the bank may charge a fee, close your account, or convert it to a checking account. The amount you can withdraw is unlimited, so you can withdraw up to the amount in the account.",
          "Just as with the interest earned on a money market, certificate of deposit, or checking account, the interest earned on savings accounts is taxable income.",
          "The financial institution where you hold your account will send a 1099 INT form at tax time whenever you earn more than $10 in interest income. The tax you’ll pay will depend on your marginal tax rate." 
        ]
      },
      {
        heading: "How to Maximize Earnings From a Savings Account",
        content:[
          "Although most major banks offer low interest rates on their savings accounts, many banks and credit unions provide much higher returns. In particular, online banks offer some of the highest savings account rates. Because they don’t have physical branches or have very few they spend less on overhead and can often offer higher, more competitive deposit rates as a result.",
          "The key is to shop around, starting with the bank where you hold your checking account. Even if that institution doesn’t offer a competitive savings account rate, it will give you a frame of reference for how much more you can earn by moving your savings or opening an additional account elsewhere.",
          "As you shop for the best rates, however, beware of account features that can curtail your earnings, or even drain them. Some promotional savings accounts will only offer the attractive rate they’re advertising for a short period of time.",
          "Others will cap the balance that can earn the promotional rate, with dollar amounts above that maximum earning a paltry rate. Even worse is a savings account with fees that cut into the interest you earn each month."
        ]
      },
      {
        heading: "How to Open a Savings Account",
        content:[
          "To set up a savings account, visit one of the bank or credit union’s branches, or establish the account online, for those institutions that offer it. You’ll need to provide your name, address, and telephone number, as well as photo identification. Also, because the account earns taxable interest, you’ll need to provide your Social Security number (SSN).",
          "Some institutions will require you to make an initial minimum deposit at the time you open the account in order to receive account opening bonus. Others will allow you to open the account first and fund it later."
        ]
      }
    ]
  },
  {
    id:2,
    title:"Current Account",
    image:currentaccount,
    sections:[
       {
        heading: "What Is the Current Account?",
        content:[
          "A country's current account is its record of the flow of money into and out of the country in the form of imports and exports, investment earnings, and foreign aid. The level of a country's current account surplus or deficit has an impact on its employment levels, economic stability, and more.",
          "The United States had a current account deficit of $303.9 billion in the fourth quarter of 2024.",
          "The current account is one component of a country's balance of payments, which includes its capital and financial account. The balance of payments is a record of all international transactions a country's individuals, businesses, and government entities conduct."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "The bottom line of a nation's current account is the number that shows whether it is bringing in more money from trade and investments than it is sending to other countries.",
          "Generally, a current account surplus is considered to be better than a current account deficit but a number of positive and negative factors are considered.",
          "A country's exchange rate, pace of economic growth, inflation rate, and government policies all influence its current account balance.",
        ],
      },
      {
        heading: "How the Current Account Works",
        content:[
          "The current account assesses a country's financial transactions with the rest of the world. It includes exports/imports, income from foreign investments, and money transfers.",
          "If a country exports more than it imports, it has a trade surplus. If it imports more, it will have a trade deficit. Income from foreign investments includes interests and dividends earned by citizens who own stocks in foreign countries, for example. Remittances include items such as money sent back home by foreigners or international aid provided to other countries.",
          "Savings account interest rates vary. With the exception of promotions promising a fixed rate until a certain date, banks and credit unions might change their rates at any time. Typically, the more competitive the rate, the more likely it is to fluctuate.",
          "Changes in the federal funds rate can trigger institutions to adjust their deposit rates. U.S. Consumer Financial Protection Bureau. The Fed is raising interest rates. What does that mean for borrowers and savers? Some institutions offer high yield savings accounts with significantly higher interest rates for larger minimum deposits, which may be worth investigating."
        ],
      },
      {
        heading: "Trade and Services",
        content:[
          "When Americans import cars from Germany or Japan, wine and cheese from France, and electronics from South Korea, they must pay those foreign companies for these goods, which is a transfer of money out of the country.",
          "Similarly, when Americans export goods to foreign buyers, such as iPhones, those foreigners must pay for these goods, which is an inflow of money. This balance between imports and exports determines whether a country has a trade surplus or deficit.",
          "Similarly, services represent an exchange of money. When international visitors travel to another country, they spend money on food, hotels, and museum tickets. Some countries with strong financial sectors, like Switzerland, earn income by providing banking services to foreigners.", 
        ]
      },
      {
        heading: "Investment Income",
        content:[
          "Investment income is a key part of a nation's current account and represents cross border earnings. It includes earnings from U.S. investments abroad (money coming in) and payments to foreign investors (money going out) with assets in the U.S.",
          "Investment income includes direct investment earnings, portfolio returns, and other interest. Many domestic individuals and companies invest in foreign businesses, stocks, bonds, and other assets, and those investments generate returns.",
          "If a country's population earns more from foreign investments than foreign investors earn from its domestic market, it positively impacts the current account.",
        ]
      },
      {
        heading: "Importance of the Current Account",
        content:[
          "Whether a country runs a surplus or deficit in its current account indicates its financial health. Countries consistently running current account deficits rely on foreign consumers, borrowed money, and foreign investments to facilitate their economies.",
          "This can lead to growing debt, a weaker currency, and economic instability. It can also deter foreign investment, which can lead to an economic crisis if foreign investment slows down or ceases.",
          "Countries with a current account surplus are generally seen as economically strong; however, a surplus isn't always an indicator of smart economics. A high current account surplus may indicate that a country relies too much on exports and does not invest responsibly in domestic growth.",
          "The current account helps policymakers, businesses, and individuals make decisions. It plays an important role in shaping trade agreements, monetary and fiscal policy, spending decisions, and business strategies."
        ]
      }
    ]
  },
    {
    id:3,
    title:"Fixed Deposit Account",
    image:fdccount,
    sections:[
       {
        heading: "What is a fixed deposit?",
        content:[
          "A fixed deposit, also known as an FD, is an investment instrument offered by banks, as well as non banking financial companies (NBFC) to their customers to help them save money. With an FD account, you can invest a sizeable amount of money at a predetermined rate of interest for a fixed period. At the end of the tenure, you receive the lump sum, along with an interest, which is a good money saving plan. Banks offers different rates of interest for a fixed deposit account.",
          "You can choose a fixed deposit for a period ranging from minimum 7-14 days to maximum 10 years. This is why an FD is sometimes called a term deposit. When you open a fixed deposit account at a specific interest rate, it is guaranteed, for the rate of interest remains the same, irrespective of any changes, which happen due to market fluctuations.",
          "The interest you earn is either paid at maturity or on periodic basis depending on your choice. You are not allowed to withdraw the money before the maturity. If you want to, you have to pay a penalty."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "A fixed deposit is an investment where you deposit a lump sum for a fixed tenure at a predetermined interest rate offering assured returns.",
          "Key features include flexible tenures, competitive interest rates and minimal risk compared to market linked investments.",
          "You can choose interest payout options like monthly, quarterly or at maturity depending on your income needs or long term goals.",
          "IDFC FIRST Bank provides fixed deposits with simple online set up, clear terms and multiple payout options to match your savings strategy."
        ],
      },
      {
        heading: "Who Should Invest in Fixed Deposit?",
        content:[
          "Fixed deposit accounts are an excellent investment vehicle for those investors who don’t want to bear any risk. If you wish to sustain the money over the years while growing wealth with steady returns, you can go for FD accounts.",
          "Many pensioners who receive a lump sum from retirement can invest their money in FD accounts so that the monthly interest payout can be used for expenses.",
          "Individuals can also set aside a lump sum for their children or minors so they can use the sum later for higher education. They can also use FD accounts if they are planning to build emergency funds, since they can be withdrawn anytime with minor penalties.",
        ],
      },
      {
        heading: "Eligibility Criteria for Fixed Deposit​",
        content:[
          "The following eligibility criteria are applicable to open an FD account in India. There may be additional criteria that are bank specific."
        ],
        points: [
          "Individuals who are resident Indians",
          "Joint account by two or more Individuals",
          "Senior citizens",
          "Minors",
          "Non Resident Indians (NRIs)",
          "Sole proprietorship",
          "Societies, trusts, clubs, associations, etc",
          "Religious and educational institutions",
          "Companies",
          "Partnership firms"
        ],
      },
      {
        heading: "Loan Against Fixed Deposit​",
        content:[
          "Most FDs provide the option to avail loans of up to 90% of the deposited amount. Consider that you have deposited Rs.1 lakh in a fixed deposit account with Bank B for a tenure of 3 years. Since you have made the deposit for a long period, the bank agrees to offer 6% p.a.",
          "However, at the end of the first year, you have come across an emergency situation and need Rs.70,000. If you withdraw the deposit prematurely, you will be penalised and will not receive the expected returns.",
          "In this scenario, the bank will suggest you take a loan on the FD instead of closing the deposit account. You can take a loan on the FD amount, utilise the money for the emergency, and pay it back before the account maturity. This allows the FD account to accrue interest as usual, and you also receive money to address the emergency at the same time.",
        ]
      },
      {
        heading: "Advantages of FD",
        content:[
          "here is the advantages of investing in a fixed deposit account:"
        ],
         points: [
          "FD returns are assured as they are not tied to the market.",
          "FD deposits are insured for up to Rs.1 lakh by the Reserve Bank of India (RBI).",
          "The accumulated interest can be credited according to the individual’s requirements, such as monthly, quarterly, or annually.",
          "An individual can claim tax deduction by investing in tax saving fixed deposits of up to Rs.1.5 lakh in a financial year.",
          "In any financial emergency, individuals can borrow up to 90% of the deposited amount against their FDS.",
          "Investment is safe as banks and other financial institutions are always under the purview of the RBI.",
          "Compounded interest makes the investment grow at a much faster rate.",
          "Premature withdrawals are allowed, so individuals will always have a corpus to fall back on in times of crisis.",
        ],
      },
      {
        heading: "Limitations of FD",
         content:[
          "While fixed deposits are a safe and reliable investment option, they do have some limitations that investors should be aware of:"
        ],
         points: [
          "Though the FD returns are safe and a particular return percentage is guaranteed, the concept hinders the possibility of earning higher returns.",
          "FD accounts come with a specific lock in period chosen by the customers themselves. The investment can be liquidated before maturity only at the cost of a penalty on the promised interest rate, which is a loss.",
          "Though individuals choose a 5 year tax saver FD account to save tax without investment risk, the returns from the account are taxable under the Income Tax Act.",
        ],
      }
    ]
  },
    {
    id:4,
    title:"Recurring Deposit Account",
    image:rdaccount,
    sections:[
       {
        heading: "What is an Recurring Deposit account?",
        content:[
          "A recurring deposit means making regular, timely deposits. It is a service provided by many banks where people can make regular deposits and earn decent returns on their investments. Understanding what a recurring deposit account is and how it works can help you understand whether it is the right savings option for you.",
          "Recurring Deposit allows users to make small monthly contributions, gradually building a substantial sum by the time of maturity. While you consistently deposit into the accounts, the accumulated amount is also accruing interest. The Recurring Deposit interest rates are usually calculated on a quarterly compounding basis. ",
          "Banks like IDFC FIRST Bank offer RDs with features designed for today's savers with flexible tenures and digital account management for ease of access and tracking."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "A Recurring Deposit (RD) account, offered by banks and post offices in India, lets a depositor invest a fixed amount every month for a specific duration (6 to 36 months) and earn interest as returns.",
          "You can create an RD Account by going to any bank/post office, filling a form, and submitting it along with your supporting documents  PAN card, proof of residence, and the first month's amount.",
          "An RD helps ensure savings discipline, and offers flexible tenures to suit individual goals, earn a steady interest, and is considered a safe investment option with moderate returns.",
        ],
      },
      {
        heading: "How does a Recurring Deposit account work?",
        content:[
          "Recurring deposits, in terms of their risk levels, are often compared to fixed deposits. Both offer low risk savings but function in a different manner. An ordinary fixed deposit account requires you to make a lump sum deposit that will continue to accrue interest over time. A recurring deposit requires you to make the contributions every month. Instead of investing a lump sum, as with fixed deposits, you are required to deposit a pre determined amount into your account each month. Recurring deposit contributions often start small, so you don’t have to create future savings at the cost of present day necessities. When your RD has matured, you can withdraw the total amount, which is your total contributions plus the interest accrued on it.",
          "An RD account means low risk savings with returns you can count on. It is a banking or postal service account in which a depositor puts a certain amount of money each month for a set length of time (commonly spanning six months to three years). This structure is for people who want to put down a set amount each month with the goal of receiving a payout after a few years.",
          "With IDFC FIRST Bank, monthly deposits can be as low as ₹100, making it accessible for beginners while also allowing high cap limit options up to ₹1,25,000 per month for seasoned savers.",
        ],
      },
      {
        heading: "How to open an Recurring Deposit Account online?",
        content:[
          "You can open a recurring deposit account through various banking channels. Here is how to open an RD online with IDFC FIRST Bank:"
        ],
        points: [
          "Log in to the IDFC FIRST Bank Mobile Banking App.",
          "Locate the option to open a recurring deposit account. ",
          "Select the IDFC FIRST Bank Savings Account from where the investment amount has to be auto debited.",
          "Enter the monthly deposit amount.",
          "Select Best Plan to get the most suitable plan or select All Plans to select a plan of your choice.",
          "Click on Create RD to finish the process and start your Recurring Deposit!",
        ],
         h2: [
          "Now, enjoy the features of a recurring deposit account and watch your savings grow over time."
        ],
      },
      {
        heading: "Advantages of Recurring Deposits",
        content:[
          "here is the advantages of Recurring Deposits "
        ],
         points: [
          "Disciplined Savings : Encourages regular, habitual saving of small, fixed amounts.",
          "Guaranteed Returns : Fixed interest rates provide safety from market fluctuations.",
          "Accessibility : Low minimum deposit amounts make it accessible to all income levels.",
          "Flexible Tenure : RDs typically range from six months to ten years.",
          "Loan Facility : Banks often allow loans of up to 90% of the deposited amount.",
          "Higher Interest than Savings Account : Generally offers better returns than standard savings accounts.",
        ],
      },
      {
        heading: "Disadvantages of Recurring Deposits ",
         content:[
          "here is the Disadvantages of Recurring Deposits:"
        ],
         points: [
          "Taxable Income : Interest earned is fully taxable according to the investor's income tax slab.",
          "Lower Returns : Usually provides lower returns than equity linked or high risk investments.",
          "No Inflation Protection : Fixed returns may not keep pace with high inflation.",
          "Penalty on Premature Withdrawal : Withdrawing funds before maturity incurs penalties and reduces earnings.",
          "Missed Payment Penalties : Failure to make monthly deposits can lead to penalties or reduced maturity amounts.",
          "Lower Liquidity : Money is locked in for a fixed term, making it less liquid than a savings account."
        ],
      }
    ]
  },
    {
    id:5,
    title:"Demat Account",
    image:demateaccount,
    sections:[
       {
        heading: "What Is Dematerialization (DEMAT)?",
        content:[
          "Dematerialization (DEMAT) is the process of converting physical stock certificates into electronic records, allowing securities to be held and traded digitally. DEMAT accounts are required by financial institutions to ensure faster, safer, and more efficient transactions.",
          "The shift, which modernized trading from the old paper based system, now applies to stocks, bonds, and mutual funds, reducing errors, lowering costs, and providing instant transaction updates.",
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "Dematerialization replaces physical stock certificates with electronic records, offering more secure and faster financial trades.",
          "DEMAT accounts facilitate seamless electronic transactions for stocks, bonds, mutual funds, and government securities.",
          "Updating accounts automatically through dematerialization reduces errors and speeds up transaction processes.",
          "Using DEMAT accounts is analogous to using bank accounts for digital transactions, avoiding paper currency handling.",
          "Dematerialization enhances security, reduces paperwork, and eliminates processing delays in financial transactions."
        ],
      },
      {
        heading: "How Does A Demat Account Work?",
        content:[
          "In general, Demat Accounts are used to hold the purchased shares by an individual"
        ],
        points: [
          "If a person intends to buy or sell a certain company's share, the first step is to log in to the Demat and Trading Account that is linked to the bank's account.",
          "When he/she places a Buy/Sell request in a trading account, the DP forwards the same to the stock exchange immediately.",
          "Let's assume a Buy order was placed. The stock exchange will run a search for a seller who intends to sell his/her shares. If the price matches, it will be taken forward to the clearance houses to get it debited from the seller's demat and credited to the buyer's materialized account.",
        ],
         h2: [
          "A significant thing to note here is that the buyer and seller may hold a demat account with DPs associated with different depositories."
        ],
      },
       {
        heading: "Features of a Demat Account ",
         content:[
          "Demat accounts offer several crucial features designed to make investing easier and safer:"
        ],
         points: [
          "Electronic Storage : By storing all securities including stocks, bonds, mutual funds, and exchange traded funds (ETFs) digitally, risk factors connected with physical certificates are greatly decreased.",
          "Simple Transfer and Trading : Online transactions are rapid and hassle free when it comes to buying or selling securities.",
          "Unified Portfolio Management : Managing many securities in a single account makes portfolio management easier for investors.",
          "Automatic Updates : To make sure you never miss any significant developments, corporate actions, including rights issues, stock splits, dividends, and bonus shares, are automatically reflected in your Demat account.",
          "Nomination Facility : In the event of unfavourable circumstances, investors may nominate beneficiaries, guaranteeing a seamless and hassle free transfer of assets to loved ones.",
        ],
      },
       {
        heading: "How to Open a Demat Account ",
         content:[
          "Opening a Demat account involves a straightforward process, which typically includes the following steps:"
        ],
         points: [
          "Choose a Depository Participant (DP):Select a trustworthy Depository Participant, (typically a bank or stockbroking company) approved by central depositories such as CDSL or NSDL.",
          "Fill out the application:Complete the online or physical account opening form that your chosen DP has provided.",
          "Send in the necessary documents:Provide the required paperwork, such as your passport sized photos, proof of address (bank statements, utility bills), proof of identification (voter ID, Aadhaar card, etc.), and PAN data.",
          "Verification Procedure:To verify your identification and the legitimacy of the documentation you have supplied, your DP may perform an online or in person verification procedure.",
          "Get Account Credentials:You can begin trading right away after receiving your Demat account information, including an account number and login details.",
        ],
      },
      {
        heading: "Benefits of Demat Accounts",
        content:[
          "Investors who opt to open Demat account can enjoy several benefits. Here are some of the most common benefits."
        ],
         points: [
          "Demat accounts eliminate the risk of damage, forgery, misplacement, or theft of physical shares.",
          "The electronic system is also considerably simpler and can be completed within hours. It has eliminated several time consuming operations, which has made the entire process streamlined and time saving.",
          "Demat accounts come with remote access benefits, provided individuals have a registered net banking facility with the concerned financial institution.",
          "Investors can merge bank accounts with dematerialized accounts to facilitate electronic fund transfers.",
          "Customers can benefit from a nomination facility if they open a Demat account online.",
          "Account holders with a specific unit of securities in their portfolio can opt to freeze their accounts for a specific period. This can prove helpful to avoid any unwanted transaction into one’s Demat account.",
        ],
      },
     
    ]
  },
    {
    id:6,
    title:"NRI Account",
     image:NRI,
    sections:[
       {
        heading: "What is an NRI Account?",
        content:[
          "An NRI Account is a type of account that Non Resident Indians (NRIs), Persons of Indian Origin (PIOs), or Overseas Citizens of India (OCIs) can open with a bank or financial institution authorized by the Reserve Bank of India. These accounts offer various banking services tailored to NRIs. The term NRI Account stands for Non  Resident Indian Account, which can be set up with banks or other authorized financial institutions.",
          "NRIs can use NRI Accounts to deposit their income, which may come from India or any other country. This income could be from employment, investments, or other sources.",
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          "NRE (Non Resident External) Account : For parking foreign income in INR. Interest earned is tax free in India, and the principal + interest are fully repatriable.",
          "NRO (Non Resident Ordinary) Account : For managing income earned in India (rent, dividends, etc.). Interest is taxable, and repatriation is restricted.",
          "FCNR (Foreign Currency Non Resident) Account : Fixed deposits held in foreign currency, protecting against exchange rate fluctuations. Fully repatriable.",
        ],
      },
      {
        heading: "Eligibility criteria for opening an NRI Account",
        content:[
          "The eligibility criteria for opening an NRI Account are defined by the Reserve Bank of India (RBI) and are relatively straightforward,ensuring that Non Resident Indians and Persons of Indian Origin can easily set up their banking operations in India. Here's what you need to know about the eligibility for opening an NRI Account:"
        ],
        points: [
          " NRI status : You must qualify as a Non Resident Indian or a Person of Indian Origin (PIO) or OCI. Generally, an NRI is an Indian citizen who resides outside India for the purpose of employment, business, or vocation or under circumstances indicating an indefinite period of stay abroad. A PIO is an individual of Indian origin who is a citizen of another country (except for Pakistan and Bangladesh), who at any time held an Indian passport, or whose parents or grandparents were citizens of India.",
          "Duration Of staying abroad : The FEMA regulations typically require an individual to spend a minimum of 182 days outside India in the preceding financial year to be considered a non resident. However, there can be exceptions based on your particular circumstances, such as the intent to stay abroad for an uncertain duration.",
          " Age : The individual must be 18 years or older to open an NRI Account independently. Minors can also have NRI Accounts opened by their guardians.",
          " Documentation : A prospective account holder should be able to provide valid documentation, including a valid passport, visa, proof of residence abroad, and a recent photograph. These documents serve as proof of identity and NRI status.",
          " Regulatory compliance : Applicants must comply with the regulations of the Foreign Exchange Management Act (FEMA) and any other applicable laws governing NRI Accounts in India.",
        ],
         h2: [
          "A significant thing to note here is that the buyer and seller may hold a demat account with DPs associated with different depositories."
        ],
      },
       {
        heading: "Documents required for NRI Account ",
         content:[
          "When opening an NRI Account, the documentation process is crucial to establish your identity and NRI status. Here is the list of NRI Account opening documents required:"
        ],
         points: [
          "Passport : A copy of your current and valid id passport, with details such as your name, address, date of birth, date and place of issue, expiration date, photograph, identity number and signature.",
          " Visa / Work Permit : A copy of your valid visa or work permit as proof of your residence abroad.",
          " Proof Of NRI status : This could be in the form of a valid employment contract, an employment letter, or a resident permit indicating your overseas address.",
          "Proof Of overseas address : This can be any valid document that verifies your address abroad, such as utility bills, bank statements, or rent agreements.",
          " Photographs : Recent passport sized photographs. typically two in number. are required.",
          " KYC documents : Additional documents for fulfilling the Know Your Customer (KYC) norms may include a PAN card, Overseas Citizen of India (OCI) card, and others as specified by the bank."
        ],
      },
       {
        heading: "Advantages of NRI Accounts ",
         content:[
          "here is the advantages of NRI Accounts:"
        ],
         points: [
          "Tax Benefits : Interest earned on NRE (Non Resident External) and FCNR (Foreign Currency Non Resident) accounts is entirely tax free in India.",
          "Easy Repatriation : Funds in NRE and FCNR accounts are fully repatriable, allowing you to move both principal and interest back to your country of residence without restrictions.",
          "Currency Protection (FCNR) : FCNR accounts hold deposits in foreign currency, protecting against Indian Rupee depreciation.",
          "Manage Indian Income (NRO) : Non Resident Ordinary (NRO) accounts are ideal for managing income earned in India, such as rent, dividends, or pensions.",
          "Investment Opportunities : NRI accounts enable investment in Indian shares, debentures, and mutual funds, often requiring a PIS (Portfolio Investment Scheme) account.",
          "Joint Operation : NRO accounts can be jointly held with a resident Indian, typically a close relative. "
        ],
      },
      {
        heading: "Disadvantages of NRI Accounts",
        content:[
          "here are the disadvantages of NRI Accounts:"
        ],
         points: [
          "Currency Risk (NRE) : Since NRE deposits are maintained in Indian Rupees, foreign currency fluctuations can reduce the value of your savings when converted back.",
          "Taxable Interest (NRO) : Interest earned on NRO accounts is taxable in India.",
          "Repatriation Limits (NRO) : Repatriation of funds from NRO accounts is subject to restrictions, generally capped at USD 1 million per financial year.",
          "Complex Regulations : Managing multiple account types (NRE/NRO) requires understanding RBI regulations to avoid compliance issues, such as depositing Indian income into an NRE account. ",
        ],
      },
     
    ]
  }
]

export const investmenttype = [
  {
    id:1,
    title:"",
     sections:[
       {
        heading: "What Is a Brokerage service?",
        content:[
          "A brokerage firm is a financial intermediary. Brokers connect buyers and sellers to complete a transaction for stock shares, bonds, options, and other financial instruments. They are compensated in fees or commissions after the transaction is complete.",
          "Full service and discount brokerages differ in available services and pricing structures. Full service brokers offer a wider range of products and services and are paid by a flat annual fee or fees per transaction. Discount brokers handle buy and sell orders directly from the investor for little to no fee, and many have tiered services at premium prices.",
          "Online brokers, who offer free stock trading but charge for other services, and robo advisors, which use algorithms for trading strategies at low fees, are changing the landscape of brokerage services."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"Brokerage firms act as intermediaries, facilitating transactions between buyers and sellers of various financial assets, such as stocks and bonds, and earn money through commissions and fees."},
          {key:"", value:"Full service brokerage firms provide a broad range of financial services, such as money management and estate planning, and generally cater to high net worth individuals who are willing to pay fees ranging from 1% to 3% of assets under management."},
          {key:"", value:"Discount brokerages and robo advisors have grown in popularity due to their low or zero commission structures for basic services, though they may offer tiered or premium options at additional costs."},
          {key:"", value:"The choice between independent and captive brokerages can impact the range of products offered, with independent advisors being held to a fiduciary standard and potentially providing a broader selection of investment options compared to captive brokers."},
          {key:"", value:"Investors should understand the differing service levels and pricing structures of brokerage firms to select one that aligns with their specific financial needs and decision making confidence."}
        ],
      },
      {
        heading: "Types of Brokerage Services",
        points: [
          {key:"Full Service Brokers : ", value:"Offer a comprehensive suite of services, including personalized investment advice, retirement planning, tax tips, and research. These are often used by high net worth individuals and charge higher fees, typically 1% to 3% of assets under management (AUM)."},
          {key:"Discount Brokers : ", value:"Focus on executing trades (stocks, ETFs, bonds) at lower costs, often with $0 commissions for online trades. They generally do not provide financial advice and cater to self directed investors."},
          {key:"Robo Advisors : ", value:"Utilize algorithms to create and manage automated, diversified portfolios, offering low cost, hands off investing."},
          {key:"Real Estate Brokers : ", value:" Facilitate the buying, selling, or leasing of properties, handling negotiations and ensuring legal compliance."},
          {key:"Insurance Brokers : ", value:" Act as intermediaries to help clients find the best insurance policies, representing the client's interests rather than the insurer's."},
          {key:"Prime Brokers : ", value:"  Provide specialized, high level services to large institutional clients like hedge funds, including securities lending, leveraged trade execution, and cash management."},
        ],
        
      },
      {
        heading: "Core Functions and Services",
        points: [
          {key:"Trade Execution : ", value:"The primary role of buying/selling securities (stocks, bonds, ETFs, options, crypto) on behalf of clients."},
          {key:"Market Research & Analysis : ", value:" Providing, reports, stock screeners, and economic commentary to guide investment decisions."},
          {key:"Account Custody & Management : ", value:" Safely holding client assets, maintaining transaction records, and providing statements."},
          {key:"Financial Planning : ", value:" Assisting with long term goals like retirement (IRA, 401(k)), education (529 plans), and estate planning."},
          {key:"Margin Trading : ", value:"  Providing loans for investors to purchase additional securities."},
        ],
        
      },
      {
        heading: "Specialized Brokerage Sectors",
        points: [
          {key:"Real Estate Brokerage : ", value:"Intermediaries for buying, selling, or leasing property, operating on commission splits, often under larger brands like RE/MAX or Coldwell Banker."},
          {key:"Insurance Brokerage : ", value:" Advising clients and finding the best insurance policies, acting in the interest of the buyer rather than the insurer."},
          {key:"Mortgage Brokerage : ", value:"  Connecting borrowers with lenders to secure mortgage loans. "},
        ]
      },
     
    ]
  },
   {
    id:2,
    title:"",
     sections:[
       {
        heading: "What Is Wealth Management?",
        content:[
          "Wealth management is an investment advisory service that uses financial services to address the needs of affluent clients.",
          "Using a consultative process, the advisor gleans information about a client’s wants and specific situation. They then tailor a personalized strategy that uses a range of financial products and services to help the client achieve their goals. This can include money management, investment advice, estate planning, accounting, life insurance, retirement planning, and tax services.",
          "While fee structures vary across comprehensive wealth management services, they are usually based on a client’s assets under management (AUM)."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"Wealth management is a holistic service addressing all facets of an affluent client's financial life, including investment management, estate planning, and tax strategies."},
          {key:"", value:"Wealth managers often tailor personalized strategies by collaborating with various professionals to meet the complex needs of high net worth individuals."},
          {key:"", value:"The wealth management industry is vast, managing over $128.9 trillion globally as of 2024, and is projected to grow significantly."},
          {key:"", value:"Fees for wealth management services vary, commonly based on assets under management (AUM), with typical fees around 1% but can decrease as asset size increases."},
          {key:"", value:"Wealth managers come with varying credentials and expertise, with top certifications including Certified Financial Planner and Chartered Financial Analyst."}
        ],
      },
      {
        heading: "Key Components of Wealth Management",
        points: [
          {key:"Investment Management : ", value:"Tailoring portfolios with stocks, bonds, and alternative assets to meet risk tolerance and goals."},
          {key:"Financial Planning : ", value:"Creating strategic, long term plans for cash flow, retirement, and wealth accumulation."},
          {key:"Tax Optimization : ", value:"Employing strategies like tax loss harvesting to minimize liabilities and improve net returns."},
          {key:"Estate Planning : ", value:" Structuring the transfer of assets to beneficiaries through wills and trusts to minimize taxes and legal issues."},
          {key:"Risk Management : ", value:"  Protecting assets against market, liquidity, and longevity risks."},
        ],
        
      },
      {
        heading: "Core Benefits and Objectives",
        points: [
          {key:"Unified Strategy : ", value:"Coordinated management of all financial aspects."},
          {key:"Personalization : ", value:" Strategies customized to unique goals and life stages."},
          {key:"Wealth Preservation & Growth : ", value:"  Focused on both growing assets and creating a legacy."},
          {key:"Professional Expertise : ", value:"  Access to in depth market analysis and specialized planning."},
        ],
        
      },
      {
        heading: "Common Wealth Management Strategies",
        points: [
          {key:"Asset Allocation : ", value:" Diversifying investments to balance risk and return."},
          {key:"Rebalancing : ", value:" Adjusting portfolios to maintain target risk levels."},
          {key:"Tax Loss Harvesting : ", value:" Selling losing investments to offset gains. "},
        ]
      },
     
    ]
  },
   {
    id:3,
    title:"",
     sections:[
       {
        heading: "What Is Retirement Planning?",
        content:[
          "Creating a retirement plan begins with determining your long term financial goals and tolerance for risk, and then starting to take action to reach those goals. The process can begin anytime during your working years, but the earlier, the better.",
          "The process of creating a retirement plan includes identifying your income sources, adding up your expenses, putting a savings plan into effect, and managing your assets. By estimating your future cash flows, you can judge whether your retirement income goal is realistic.",
          "Needless to say, a retirement plan is not a static document. You’ll need to update it from time to time as well as review it to monitor your progress."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"It is never too early or too late to start a retirement plan."},
          {key:"", value:"A retirement plan is a strategy for long term saving, investing, and finally withdrawing money you accumulate to achieve a financially comfortable retirement."},
          {key:"", value:"A key part of a retirement plan is taking advantage of one of the government approved investment vehicles, such as an individual retirement account (IRA) or a 401(k) account, which offers tax advantages to retirement savers."},
          {key:"", value:"Your retirement plan needs to take into account your estimated future expenses, liabilities, and life expectancy."},
        ],
      },
      {
        heading: "How Retirement Planning Works",
          content:[
            "A retirement plan is your preparation for a good life after you’re done working to pay the bills or at least done working a full time job. But it’s not all about money.",
            "The non financial aspects include lifestyle choices such as how you want to spend your time in retirement and where you’ll live. A holistic approach to retirement planning considers all these areas.",
            "The goals for your retirement plan will change in focus over time:",
          ],
        points: [
          {key:"", value:"Early in a person’s working life, your contribution to retirement savings may be modest. The reward is 40 plus years of investment growth."},
          {key:" ", value:"During the middle of your career, when your income may be at its peak, you might set specific income or asset targets and take steps toward achieving them."},
          {key:"", value:"Once you reach retirement age, you go from accumulating assets to what planners call the distribution phase. You’re no longer paying into your retirement account(s). Instead, you start collecting the rewards of decades of savings."},
         
        ],
        
      },
      {
        heading: "Estimating Expenses",
        content:[
          "Your post retirement expenses largely determine that magic number.",
          "It’s a good idea to create a retirement budget, calculating estimated costs for housing, health insurance, food, clothing, and transportation.",
          "And since you’ll have more free time on your hands, you may also want to factor in the cost of entertainment, hobbies, and travel.",
          "It may be hard to come up with concrete figures, but a reasonable estimate will be helpful.",
        ],
       
      },
      {
        heading: "Key Components of Retirement Planning",
        points: [
          {key:"Assessment : ", value:" Determine your retirement age, desired lifestyle, and current financial standing."},
          {key:"Target Corpus : ", value:" Calculate the total savings required, typically aiming for 25 times your annual income."},
          {key:"Investment Options : ", value:"Utilize instruments like the National Pension System (NPS), Public Provident Fund (PPF), mutual funds, and employee provident funds (EPF)."},
          {key:"Risk Management : ", value:" As retirement nears, shift investments from high risk equity to lower risk debt instruments to protect the corpus."},
          {key:"Tax Efficiency : ", value:"  Leverage tax deductions under Section 80C (up to ₹1.5 lakh) and Section 80CCC for annuity plans."},
        ]
      },
     
    ]
  },
    {
    id:4,
    title:"",
     sections:[
       {
        heading: "What Is a Trust Company?",
        content:[
          "A trust company is a legal entity that acts as a fiduciary, agent, or trustee on behalf of a person or business. It can act as the custodian for a trust or estate, managing assets and property according to the instructions of the trustor on behalf of their eventual benefactors.",
          "Trust companies typically charge a fee for their services, which can be either a flat fee or a percentage of their assets."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"Trust companies act as fiduciaries, managing and transferring assets for individuals, businesses, and estates."},
          {key:"", value:"These companies offer services such as wealth and asset management, handling tasks like bill paying and estate planning."},
          {key:"", value:"Trust companies charge fees, often based on a percentage of assets or a flat annual rate."},
          {key:"", value:"They are regulated by the Office of the Comptroller of the Currency and, if applicable, other financial regulatory bodies."},
          {key:"", value:"Employing a trust company can help prevent family disputes over estate planning by serving as a neutral third party."}
        ],
      },
      {
        heading: "Understanding the Function of a Trust Company",
        content:[
          "Although trusts often have an individual as the trustee, a trust company can also serve in this role. For example, a trust company can be a successor trustee for a trust when there are no financially responsible family members available to take on that role.",
          "When the grantor, the person who created the trust, passes away, the trust company becomes the new trustee and manages the assets according to the trust's terms.",
          "A trust company doesn't own the assets assigned to it but has a legal duty to care for them on behalf of others.",
          "Trust companies manage trusts and similar arrangements for a fee, deducted annually or upon asset transfer to beneficiaries.",
          "Various trusts, including charitable ones, can use trust companies as trustees."
        ],
       
      },
      {
        heading: "Key Aspects of Trust Services",
        points: [
          {key:"Trust Companies : ", value:"  Act as fiduciaries managing assets, providing services such as financial planning, guardianship, and managing non financial assets. They offer a centralized, efficient, and professional alternative to individual trustees."},
          {key:"Trustees : ", value:" A person or firm that holds title to assets and administers them based on the trust document's stipulations, with a legal fiduciary duty to the beneficiaries."},
          {key:"Common Purposes : ", value:" Used for asset protection from creditors, controlling the timing of beneficiary inheritances, and reducing estate taxes."},
          {key:"Types of Trusts : ", value:" Key distinctions include revocable (changeable by the grantor) and irrevocable (cannot be changed, usually for tax/asset protection). Others include testamentary trusts (created at death) and special needs trusts."},
        ]
      },      
      {
        heading: "Key Services Offered :",
        points: [
          {key:"Wealth & Asset Management : ", value:"Professional management of investment portfolios."},
          {key:"Estate Planning : ", value:" Structuring asset distribution to beneficiaries."},
          {key:"Trust Administration : ", value:"Fulfilling the trustee's duties, including record keeping and tax preparation."},
          {key:"Guardianship : ", value:" Managing assets for minors or incapacitated persons. "},
        ],
      },
     
    ]
  },
    {
    id:5,
    title:"",
     sections:[
       {
        heading: "What Is Private Banking?",
        content:[
          "Private banking consists of personalized financial services and products offered to the high net worth individual (HNWI) clients of a retail bank or other financial institution. It includes a wide range of wealth management services, and all provided under one roof. Services include investing and portfolio management, tax services, insurance, and trust and estate planning.",
          "While private banking is aimed at an exclusive clientele, consumer banks and brokerages of every size offer it. This offering is usually through special departments, dubbed private banking or wealth management divisions."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"Private banking is an enhanced offering for the high net worth individual (HNWI) clients of a financial institution."},
          {key:"", value:"Private banking consists of personalized financial and investment services and products from a dedicated personal banker."},
          {key:"", value:"Private banking clients typically receive discounts or preferential pricing on financial products."},
          {key:"", value:"However, the range of products and investment expertise offered by a private bank may be limited compared to other providers."},
        ],
      },
      {
        heading: "How Private Banking Works",
        content:[
          "Private banking includes common financial services like checking and savings accounts, but with a more personalized approach: A relationship manager or private banker is assigned to each customer to handle all matters. The private banker handles everything from involved tasks, like arranging a jumbo mortgage, to the mundane like paying bills. However, private banking goes beyond CDs and safe deposit boxes to address a client's entire financial situation. Specialized services include investment strategy and financial planning advice, portfolio management, customized financing options, retirement planning, and passing wealth on to future generations.",
          "While an individual may be able to conduct some private banking with $50,000 or less in investable assets, most financial institutions set a benchmark of six figures' worth of assets, and some exclusive entities only accept clients with at least $1 million to invest."
        ],
       
      },
      {
        heading: "Key Components of Private Banking ",
        points: [
          {key:"Wealth Management & Investment Strategy : ", value:"  Customized portfolios, asset management, and access to exclusive alternative investments (real estate, commodities)."},
          {key:"Tailored Lending Solutions : ", value:" Bespoke mortgages and loans designed to handle complex cash flows, often leveraging existing assets."},
          {key:"Financial Planning & Advisory : ", value:" Comprehensive trust and estate planning, tax optimization, and philanthropic advisory."},
          {key:"Exclusive Client Services : ", value:" Dedicated, highly accessible relationship managers providing personalized service."},
          {key:"Platforms & Technology : ", value:"Modern private banks are focusing on digital platforms to provide holistic views of client holdings, tailored to high net worth needs."}
        ]
      },      
      {
        heading: "Key Players and Structure :",
        points: [
          {key:"Major Institutions : ", value:"Firms like J.P. Morgan Private Bank and Coutts offer these services, as detailed in the Wikipedia entry on private banking."},
          {key:"Service Delivery : ", value:"  Services are often delivered through specialized departments within larger financial institutions."},
        ],
      },
     
    ]
  },
   {
    id:6,
    title:"",
     sections:[
       {
        heading: "What Is Corporate Finance?",
        content:[
          "Corporate finance is a subfield of finance that deals with how corporations address funding sources, capital structuring, accounting, and investment decisions.",
          "Corporate finance is also often concerned with maximizing shareholder value through long and short term financial planning and implementing various strategies. Corporate finance activities range from capital investment to tax considerations."
        ],
        pointheading:"KEY TAKEAWAYS",
        points: [
          {key:"", value:"Corporate finance is concerned with how businesses fund their operations to maximize profits and minimize costs."},
          {key:"", value:"It deals with the day to day demands on business cash flows and long term financing goals (e.g., issuing bonds)."},
          {key:"", value:"Corporate finance also involves monitoring cash flows, accounting, preparing financial statements, and taxation."},
          {key:"", value:"Determining whether or not to issue a dividend is another corporate finance activity."},
        ],
      },
      {
        heading: "Understanding Corporate Finance",
        content:[
          "Corporate finance has three main areas: capital budgeting, capital financing, and working capital management. Capital budgeting is the process of prioritizing funds toward the most profitable projects. Capital financing is determining how a company's investments and endeavors will be financed. Working capital management is concerned with cash flow for day to day operations and maintaining liquidity.",
          "While not necessarily an area of corporate finance, dividend distributions to shareholders are also a main concern because, in a publicly owned company, shareholders are usually owners and expect returns for their investments."
        ],
       
      },
      {
        heading: "Core Areas of Corporate Finance ",
        content:[
          "The field is traditionally divided into three primary activities:"
        ],
        points: [
          {key:"Capital Budgeting : ", value:" The process of identifying, evaluating, and selecting long term investment projects (e.g., building a new plant or launching a product) that will generate the highest risk adjusted returns."},
          {key:"Capital Financing : ", value:" Determining the optimal mix of debt (loans/bonds) and equity (selling shares) to fund operations while minimizing the Weighted Average Cost of Capital (WACC)."},
          {key:"Working Capital Management : ", value:" Managing short term assets (cash, inventory) and liabilities (accounts payable) to ensure the company has sufficient liquidity for day to day operations. "},
        ]
      },      
      {
        heading: "Key Financial Concepts & Tools :",
        content:[
          "Corporate finance relies on several quantitative methods to guide strategic decisions:"
        ],
        points: [
          {key:"Net Present Value : ", value:"Calculates the difference between the present value of cash inflows and outflows. A positive NPV indicates a profitable project."},
          {key:"Internal Rate of Return : ", value:" The discount rate at which the NPV of a project equals zero. Projects are typically accepted if the IRR exceeds the company's cost of capital."},
          {key:"Time Value of Money : ", value:"The principle that money available now is worth more than the same amount in the future due to its potential earning capacity."},
          {key:"Risk Return Tradeoff : ", value:"The understanding that higher potential returns are generally associated with higher risks."},
          {key:"Capital Structure Theories : ", value:"Includes the Modigliani Miller Theorem (capital structure relevance), Trade Off Theory (balancing tax benefits vs. bankruptcy costs), and Pecking Order Theory (prioritizing internal funds first)."}
        ],
      },
     
    ]
  }
]
